// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__3XULa","icon":"styles_icon__4ZuEb","icon_box":"styles_icon_box__HG-BO","tips":"styles_tips__1SRk_","btn":"styles_btn__2mHN5"};